import state from './moduleSettingsState'
import actions from './moduleSettingsActions'
import getters from './moduleSettingsGetters'
import mutations from './moduleSettingsMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
